// Order summary with running estimate — mirrors the drop form's order-summary.
import { computeSummary } from "../../lib/dropPricing";
import type { DropFormState } from "../../lib/dropState";

export function OrderSummary({ fd, isClubMember, isMailIn = false }: { fd: DropFormState; isClubMember: boolean; isMailIn?: boolean }) {
  const { groups, total, note } = computeSummary(fd, isClubMember, isMailIn);
  return (
    <div className="mt-3 border border-line rounded-xl overflow-hidden">
      {groups.map((g) => (
        <div key={g.title} className="px-4 py-3 border-b border-line-soft">
          <h3 className="text-[12px] font-semibold uppercase tracking-wide text-ink-subtle mb-2">{g.title}</h3>
          {g.rows.map((r, i) => (
            <div key={i} className="flex justify-between gap-3 text-[13px] mb-1 last:mb-0">
              <span className="text-ink whitespace-pre-line">{r.label}</span>
              {r.price && (
                <span
                  className={`whitespace-nowrap ${
                    r.perk ? "text-sev-success font-medium" : r.muted ? "text-ink-subtle italic" : "text-navy font-medium"
                  }`}
                >
                  {r.price}
                </span>
              )}
            </div>
          ))}
        </div>
      ))}
      <div className="px-4 py-3 bg-navy-soft/40">
        <div className="flex justify-between items-center">
          <h3 className="text-ink font-semibold">Estimated Total</h3>
          <span className="text-navy font-bold text-2xl">${total.toFixed(2)}</span>
        </div>
        <p className="text-ink-subtle text-[12px] mt-1 text-right">{note}</p>
      </div>
    </div>
  );
}
